import { getLocalStorageKey } from './local-storage.service';
import { LOCAL_STORAGE_LANGUAGE_KEY } from '../i18n/i18n';
import { apiClient } from '@solid/shared/services/api.service';

apiClient.interceptors.request.use(req => {
  req.headers['Accept-Language'] = getLocalStorageKey(LOCAL_STORAGE_LANGUAGE_KEY) ?? 'en';
  return req;
}, console.error);

export default apiClient;
